import { render } from "./ServiziExtraPrenotatiDataTable.vue?vue&type=template&id=275ab3aa"
import script from "./ServiziExtraPrenotatiDataTable.vue?vue&type=script&lang=js"
export * from "./ServiziExtraPrenotatiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__